import BaseScenesPermissions from 'models/Permissions/BaseScenesPermissions'

class MultiquoteConsortiumPermissions extends BaseScenesPermissions {}

export default MultiquoteConsortiumPermissions
